import { ModalWrapper } from './ModalWrapper';
import LogoIcon from 'public/icons/icon-192x192.png';
import { browserName } from 'react-device-detect';
import { Share } from 'components/icons/Share';
import { LongArrow } from 'components/icons/LongArrow';
import { PlusInSquare } from 'components/icons/PlusInSquare';

type Props = {
  onClose: () => void;
};

export const PWAInstructionModal = ({ onClose }: Props) => {
  const numClassName = 'rounded-full flex items-center justify-center bg-brand size-6 mr-3';

  const arrowClasses = (() => {
    switch (browserName) {
      case 'Mobile Safari':
        return 'safariArrowBounce size-12 absolute bottom-6 text-brand';
      case 'Chrome':
        return 'chromeArrowBounce size-12 absolute top-12 right-3 text-brand arrowBounce transform';
      default:
        return 'hidden';
    }
  })();

  return (
    <ModalWrapper contentWrappesClassName="flex items-center justify-center w-[90%] max-w-[400px]" onClose={onClose}>
      <div className="bg-secondary p-5 border border-zinc-700 rounded-xl flex flex-col justify-center lg:flex-row items-center relative w-full">
        <img
          src={LogoIcon.src}
          alt="Krush Logo"
          className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-6 size-12"
        />
        <div className="text-center lg:text-left py-2">
          <h2 className="text-xl font-semibold mb-6">Install the Krush App</h2>

          <ul className="flex flex-col gap-6">
            <li className="flex">
              <span className={numClassName}>1</span>
              Tap the
              <Share className="size-5 mx-1" />
              button below
            </li>
            <li className="flex">
              <span className={numClassName}>2</span>
              <p className="flex-1 flex items-center flex-wrap text-left">
                Select
                <span className="bg-brand2 p-[2px] mx-1 rounded-lg flex items-center">
                  Add to Home Screen
                  <PlusInSquare className="size-5 mx-1" />
                </span>
                from the menu that pops up. You may need to scroll down to find this menu item.
              </p>
            </li>

            <li className="flex items-center">
              <span className={numClassName}>3</span>
              Open the
              <div className="mx-2 border border-primary p-2 rounded-lg">
                <img src={LogoIcon.src} alt="Krush Logo" className="size-8" />
              </div>
              app
            </li>
          </ul>
        </div>
      </div>

      <LongArrow className={arrowClasses} />
    </ModalWrapper>
  );
};
